import { useState } from "react";
import {
    Box,
    Button,
    Collapsible,
    HStack,
    IconButton,
    Input,
    Select,
    VStack,
    Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { HiStar, HiChevronDown } from "react-icons/hi2";
import DateInput from "./DateInput";

const MobileFiltersPanel = ({
    searchQuery,
    onSearchChange,
    statusFilter,
    onStatusChange,
    statusCollection,
    showFavoriteOnly,
    onFavoriteToggle,
    createdFrom,
    onCreatedFromChange,
    createdTo,
    onCreatedToChange,
}) => {
    const { t } = useTranslation("models");
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Box display={{ base: "block", md: "none" }} w="full">
            <Collapsible.Root open={isOpen} onOpenChange={(e) => setIsOpen(e.open)}>
                <HStack gap={2}>
                    <Collapsible.Trigger asChild>
                        <Button variant="outlined" size="sm" flex={1}>
                            <HStack justify="space-between" w="full">
                                <Text fontSize="sm">{t("recruitmentDetailPage.filtersButton")}</Text>
                                <Box
                                    transform={isOpen ? "rotate(180deg)" : "none"}
                                    transition="transform 0.2s"
                                >
                                    <HiChevronDown />
                                </Box>
                            </HStack>
                        </Button>
                    </Collapsible.Trigger>
                    <IconButton
                        variant="ghost"
                        size="sm"
                        aria-label="showFavoriteOnly"
                        color={showFavoriteOnly ? "yellow.400" : "gray.500"}
                        onClick={onFavoriteToggle}
                        flexShrink={0}
                    >
                        <HiStar />
                    </IconButton>
                </HStack>

                <Collapsible.Content>
                    <VStack w="full" gap={3} pt={3} align="stretch">
                        <Input
                            placeholder={t("recruitmentDetailPage.searchPlaceholder")}
                            value={searchQuery}
                            onChange={(e) => onSearchChange(e.target.value)}
                            size="md"
                            bg="white"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="md"
                            color="gray.900"
                            _placeholder={{ color: "gray.400" }}
                            _hover={{ borderColor: "gray.300" }}
                            _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 1px var(--chakra-colors-purple-400)" }}
                        />
                        <HStack gap={2} w="full">
                            <DateInput
                                placeholder={t("candidatePage.filterCreatedFrom")}
                                value={createdFrom ?? ""}
                                onChange={(e) => onCreatedFromChange(e.target.value)}
                                size="md"
                                bg="white"
                                border="1px solid"
                                borderColor="gray.200"
                                borderRadius="md"
                                color="gray.900"
                                _placeholder={{ color: "gray.400" }}
                                _hover={{ borderColor: "gray.300" }}
                                _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 1px var(--chakra-colors-purple-400)" }}
                                flex={1}
                            />
                            <DateInput
                                placeholder={t("candidatePage.filterCreatedTo")}
                                value={createdTo ?? ""}
                                onChange={(e) => onCreatedToChange(e.target.value)}
                                size="md"
                                bg="white"
                                border="1px solid"
                                borderColor="gray.200"
                                borderRadius="md"
                                color="gray.900"
                                _placeholder={{ color: "gray.400" }}
                                _hover={{ borderColor: "gray.300" }}
                                _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 1px var(--chakra-colors-purple-400)" }}
                                flex={1}
                            />
                        </HStack>
                        <Select.Root
                            collection={statusCollection}
                            value={statusFilter}
                            onValueChange={(e) => onStatusChange(e.value)}
                            multiple
                            size="sm"
                            w="full"
                        >
                            <Select.HiddenSelect />
                            <Select.Control>
                                <Select.Trigger
                                    bg="white"
                                    border="1px solid"
                                    borderColor="gray.200"
                                    borderRadius="md"
                                    fontSize="sm"
                                    color="gray.900"
                                    _hover={{ borderColor: "gray.300" }}
                                    _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 1px var(--chakra-colors-purple-400)" }}
                                >
                                    <Select.ValueText color="gray.900" placeholder={t("candidateStatus.all")} />
                                </Select.Trigger>
                                <Select.IndicatorGroup>
                                    <Select.Indicator color="gray.500" />
                                </Select.IndicatorGroup>
                            </Select.Control>
                            <Select.Positioner>
                                <Select.Content bg="white" borderColor="gray.200" boxShadow="0 4px 24px rgba(23,21,31,0.12)">
                                    {statusCollection.items.map((opt) => (
                                        <Select.Item item={opt} key={opt.value} color="gray.900" _hover={{ bg: "purple.50" }}>
                                            {opt.label}
                                            <Select.ItemIndicator />
                                        </Select.Item>
                                    ))}
                                </Select.Content>
                            </Select.Positioner>
                        </Select.Root>
                    </VStack>
                </Collapsible.Content>
            </Collapsible.Root>
        </Box>
    );
};

export default MobileFiltersPanel;
